import { render, staticRenderFns } from "./SelectYear.vue?vue&type=template&id=17139ba2&"
import script from "./SelectYear.vue?vue&type=script&lang=js&"
export * from "./SelectYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports